<template>
  <v-table v-if="chart.report_data.length > 0">
    <thead>
      <tr :class="uuid" :id="uuid+'_header'">
        <th class="text-left">
          Обращение
        </th>
        <th class="text-left">
          Описание
        </th>
        <th class="text-left">
          Статус
        </th>
        <th class="text-left">
          Пояснение
        </th>
        <th class="text-left">
          Дата восстановления работоспособности
        </th>
        <th class="text-left">
          Стоимость восстановления
        </th>
        <th class="text-left">
          Требуемые ресурсы (ч/часы)
        </th>
        <th class="text-left">
          Плановая дата
        </th>
      </tr>
    </thead>
    <tbody>
    <tr v-for="(line, index) in this.chart.report_data" :key="line" :class="uuid" :id="uuid+'_'+index">
      <td>{{ line['ОбращениеПРЕДСТАВЛЕНИЕ'] }}</td>
      <td>{{ line['Описание'] }}</td>
      <td>{{ line['Статус'] }}</td>
      <td>{{ line['ЗначениеСтатусаПрПРЕДСТАВЛЕНИЕ'] }}</td>
      <td>
        <span v-if="line['ДатаВосстановленияРаботоспособности']">{{ moment(line['ДатаВосстановленияРаботоспособности']).format('DD.MM.YYYY HH:mm:ss') }}</span>
        <span v-else>Не указано</span></td>
      <td>{{ line['СуммаТЧДокумента'] }}</td>
      <td>{{ line['ПлановаяТрудоемкость'] }}</td>
      <td>
        <span v-if="line['ДатаПлановогоУстранения']">{{ moment(line['ДатаПлановогоУстранения']).format('DD.MM.YYYY') }}</span>
        <span v-else>Не указано</span>
      </td>
    </tr>
    </tbody>
  </v-table>
  <v-table :class="uuid" :id="uuid+'_empty'" v-else>
    <thead>
    <tr>
      <th class="text-left">
        Обращение
      </th>
      <th class="text-left">
        Описание
      </th>
      <th class="text-left">
        Статус
      </th>
      <th class="text-left">
        Пояснение
      </th>
      <th class="text-left">
        Дата восстановления работоспособности
      </th>
      <th class="text-left">
        Стоимость восстановления
      </th>
      <th class="text-left">
        Требуемые ресурсы (ч/часы)
      </th>
      <th class="text-left">
        Плановая дата
      </th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td colspan="8">Информация отсутствует!</td>
    </tr>
    </tbody>
  </v-table>
</template>

<script>

import moment from "moment";

export default {
  name: "5ea47744-bf91-11eb-811e-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  methods: {
    moment
  }
}
</script>
